/* RemixApps.js */

import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import Strings from '../../translations/Translations';
import AppleStoreImage from '../../assets/img/apple_pp_store-267x89.png';
import PlayStoreImage from '../../assets/img/google-play-badge-300x89.png';
import WebAppImage from '../../assets/img/banner_popfans_web.png';
import PopFansIcon from '../../assets/img/popfans-musicvideos-icon.png';
import PepblastIcon from '../../assets/img/pepblast-icon.png';
import RemixIcon from '../../assets/img/remix-icon.png';

const POPFANS_APP_IOS_LINK = process.env.REACT_APP_POPFANS_APP_IOS_LINK;
const POPFANS_APP_ANDROID_LINK = process.env.REACT_APP_POPFANS_APP_ANDROID_LINK;
const POPFANS_APP_WEB = process.env.REACT_APP_POPFANS_APP_WEB;
const REMIX_APP_IOS_LINK = process.env.REACT_APP_REMIX_APP_IOS_LINK;
const REMIX_APP_ANDROID_LINK = process.env.REACT_APP_REMIX_APP_ANDROID_LINK;
const REMIX_APP_WEB = process.env.REACT_APP_REMIX_APP_WEB;
const PEPBLAST_APP_IOS_LINK = process.env.REACT_APP_PEPBLAST_APP_IOS_LINK;
const PEPBLAST_APP_ANDROID_LINK = process.env.REACT_APP_PEPBLAST_APP_ANDROID_LINK;

export default function RemixApps() {
  return (
    <>
      <Row className='my-3'>
        <Col>
          <p className='text-muted'>{Strings('apps_description')}</p>
        </Col>
      </Row>
      <Row className='my-4'>

        {/* PopFans App */}
        <Col md={6} className='mb-3'>
          <Card className='shadow-lg border-0'>
            <CardBody>
              <Row className='align-items-center'>
                <Col md={4}>
                  <img src={PopFansIcon} className='img-fluid' alt={Strings('popfans_music_videos')} />
                </Col>
                <Col md={8}>
                  <h4>{Strings('popfans_music_videos')}</h4>
                  <p>{Strings('popfans_music_videos_description')}</p>
                  <p>
                    <a href={POPFANS_APP_IOS_LINK} target="_blank" rel="noopener noreferrer">
                      <img src={AppleStoreImage} className="mr-2 get_app_image_button" alt={Strings('download_popfans_app_for_ios')} />
                    </a>
                    <a href={POPFANS_APP_ANDROID_LINK} target="_blank" rel="noopener noreferrer">
                      <img src={PlayStoreImage} className="mr-2 get_app_image_button" alt={Strings('download_popfans_app_for_android')} />
                    </a>
                    <a href={POPFANS_APP_WEB} target="_blank" rel="noopener noreferrer">
                      <img src={WebAppImage} className="get_app_image_button" alt={Strings('access_popfans_web_app')} />
                    </a>
                </p>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        {/* Remix App */}
        <Col md={6} className='mb-3'>
          <Card className='shadow-lg border-0'>
            <CardBody>
              <Row className='align-items-center'>
                <Col md={4}>
                  <img src={RemixIcon} className='img-fluid' alt={Strings('remix_social_video')} />
                </Col>
                <Col md={8}>
                  <h4>{Strings('remix_social_video')}</h4>
                  <p>{Strings('remix_social_video_description')}</p>
                  <p>
                    <a href={REMIX_APP_IOS_LINK} target="_blank" rel="noopener noreferrer">
                      <img src={AppleStoreImage} className="mr-2 get_app_image_button" alt={Strings('download_popfans_app_for_ios')} />
                    </a>
                    <a href={REMIX_APP_ANDROID_LINK} target="_blank" rel="noopener noreferrer">
                      <img src={PlayStoreImage} className="mr-2 get_app_image_button" alt={Strings('download_popfans_app_for_android')} />
                    </a>
                    <a href={REMIX_APP_WEB} target="_blank" rel="noopener noreferrer">
                      <img src={WebAppImage} className="get_app_image_button" alt={Strings('access_popfans_web_app')} />
                    </a>
                </p>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

        {/* PepBlast App */}
        <Col md={6} className='mb-3'>
          <Card className='shadow-lg border-0'>
            <CardBody>
              <Row className='align-items-center'>
                <Col md={4}>
                  <img src={PepblastIcon} className='img-fluid' alt={Strings('pepblast_app')} />
                </Col>
                <Col md={8}>
                  <h4>{Strings('pepblast_app')}</h4>
                  <p>{Strings('pepblast_app_description')}</p>
                  <p>
                    <a href={PEPBLAST_APP_IOS_LINK} target="_blank" rel="noopener noreferrer">
                      <img src={AppleStoreImage} className="mr-2 get_app_image_button" alt={Strings('download_popfans_app_for_ios')} />
                    </a>
                    <a href={PEPBLAST_APP_ANDROID_LINK} target="_blank" rel="noopener noreferrer">
                      <img src={PlayStoreImage} className="mr-2 get_app_image_button" alt={Strings('download_popfans_app_for_android')} />
                    </a>
                </p>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>

      </Row>
    </>
  );
}
